import { validate as emailValidate } from "email-validator";
import React from "react";

import { ErrorMessage } from "./error_message";

const EmailInput = ({ form }) => {
  function isValidEmail(email) {
    if (emailValidate(email)) return true;
    return "Email not valid";
  }
  return (
    <>
      {/*
      NOTE: the existence of the dummy field below is related to
      why we need to use names like realemail an realpassword
      in the fields we actually care about.
      See https://app.asana.com/0/1199508238968936/1199161091094173, and
      don't change this unless you know what you're doing.
      */}
      <input style={{ display: "none" }} type="text" name="email-fake" />
      <label className="mb5">
        <p className="text-black-tint-40 bold body-s mb1 mt0">Email Address</p>
        {/*
        NOTE: there are good reasons why the name of this input is realemail.
        See https://app.asana.com/0/1199508238968936/1199161091094173, and
        don't change this unless you know what you're doing.
        */}
        <input
          name="realemail"
          id="js-email"
          style={{
            outlineColor: form.errors.realemail?.message ? "var(--red)" : "var(--blue)",
          }}
          className="fds-input body-s"
          placeholder="mary@company.com"
          autoComplete="chrome-off"
          ref={form.register({
            required: "Email address is required",
            validate: {
              isValidEmail,
            },
          })}
        />
        {form.errors.realemail ? <ErrorMessage msg={form.errors.realemail.message} /> : null}
      </label>
    </>
  );
};

export { EmailInput };
